import { useEffect, useState } from "react"
import { 
    SidePopupContainer, FlexColumn, Button, 
    Form, FormGroup, FlexRow, AppSpan 
} from "src/style"
import { RiCloseFill } from "react-icons/ri"

export const Add_Edit_Tag: React.FC<any> = ({getTags, rowData, close}) => {
    const [input, setInput] = useState({tagName: ''})

    useEffect(() => {
        if (rowData?.tagName) {
            setInput({...input, tagName: rowData.tagName})
        }
    }, [rowData])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        
        if (getTags) getTags()
        close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{rowData ? 'Edit Tag' : 'Create New Tag'}</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Tag name</label>
                        <input 
                            placeholder="Enter category name" 
                            name='tagName'
                            value={input.tagName}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    
                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}